<template>
    <div v-if="form">
        <template v-if="form.opcoesEntrada.length > 0">
            <rkm-row cols="2">
                <rkm-col
                    v-for="opcaoEntrada in form.opcoesEntrada"
                    v-bind:key="opcaoEntrada.id"
                    class="mb-3"
                >
                    <template v-if="opcaoEntrada.prioridadeObrigatoria">
                        <rkm-button
                            @click="$refs.ModalPrioridade.open(centroCusto, opcaoEntrada)"
                            block
                            class="big-button"
                            color="primary"
                        >
                            {{ opcaoEntrada.nome }}
                        </rkm-button>
                    </template>

                    <template v-else>
                        <rkm-button
                            @click="save(opcaoEntrada)"
                            block
                            class="big-button"
                            color="primary"
                        >
                            {{ opcaoEntrada.nome }}
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <ModalPrioridade
                :prioridades="form.prioridades"
                ref="ModalPrioridade"
            />
        </template>

        <template v-else>
            <rkm-row>
                <rkm-col>
                    <rkm-alert>
                        Registre uma opção de entrada para continuar
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </template>
    </div>
</template>

<script>
// Componentes.
import ModalPrioridade from './components/prioridade/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Utils.
import senha from '@/utils/painel-senha/impressao/senha'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { ModalPrioridade },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('painelSenha.fila')
        }
    },
    data: () => ({
        form: null,
        utils: { senha },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.fila.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(opcaoEntrada) {
            const request = {
                centro_custo_id: this.centroCusto.id,
                opcao_entrada_id: opcaoEntrada.id,
                prioridade_id: null,
            }

            this.setLoading()

            this.repositories.fila.store(request)
                .then(response => {
                    const params = {
                        infraestrutura: this.lotacao.infraestrutura.nome,
                        setor: this.centroCusto.setor.nome,
                        senha: response.data.senha,
                        data: response.data.dataEmissao,
                        hora: response.data.horaEmissao,
                        cliente: this.cliente.nome,
                    }

                    this.utils.senha.print(params)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>

<style scoped>
    .big-button {
        height: 100px;
    }
</style>